import { API_ENDPOINTS } from './src-config-api-config.js';
import { getMIAWEnv } from './src-utils-session-storage-utils.js';

const initChatConfig = async (locale) => {
  const res = await fetch(API_ENDPOINTS.SF_CONFIG(locale));
  if (!res.ok) {
    throw new Error("Failed to fetch SF config");
  }
  const sfConfig = await res.json();
  const { productionConfig, sandboxConfig, devsConfig } = sfConfig;
  const env = getMIAWEnv();
  if (env === "sandbox") {
    return sandboxConfig;
  } else if (env === "devs") {
    if (devsConfig) return devsConfig;
    console.warn("Dev config not found, falling back to sandbox config");
    return sandboxConfig;
  }
  return productionConfig;
};
const getQueue = (selectedQueue, queueMapping) => {
  return queueMapping?.[selectedQueue] || queueMapping?.["default"] || "";
};
const getQuestfromIntent = (intent) => {
  switch (intent) {
    case "checkout":
      return "checkout";
    case "design":
      return "design";
    case "digital":
      return "digital";
    case "order":
    default:
      return "default";
  }
};

export { getQuestfromIntent, getQueue, initChatConfig };
//# sourceMappingURL=src-utils-miaw-init-chat-utils.js.map
